export default function HolyCommunionAtHomePage () {
    return(
        <div class="flex justify-center min-h-screen">
            <div class="text-center max-w-2xl p-6">
                <h1 className="text-3xl font-bold text-center my-6">Holy Communion at Home</h1>
                <p class="text-base text-black mb-6">
                    If you wish to receive Communion at home, please contact the Parish Office and we will put you in contact
                    with one of our Deacons, Malcolm, Chris or Justin who will visit you with a Eucharistic Minister and, if 
                    need be, arrange for someone to come out on a regular basis, if this is something you would like.
                </p>
                <div className="mt-16 w-full flex justify-center flex-col items-center space-y-6 sm:flex-row sm:space-y-0 sm:space-x-8">
                    <img
                    src="/pictures/Offering.jpg"
                    alt="FHC 1"
                    className="w-60 h-60 object-cover rounded-xl shadow-md"
                    />
                    {/* <img
                    src="/pictures/FHC_1.jpg"
                    alt="FHC 2"
                    className="w-60 h-60 object-cover rounded-xl shadow-md"
                    />
                    <img
                    src="/pictures/FHC_2.jpg"
                    alt="FHC 3"
                    className="w-60 h-60 object-cover rounded-xl shadow-md"
                    /> */}
                </div>
            </div>
        </div>
    );
}